import * as React from "react";
export const PropriedadeBottom = () => {
  return (
    <React.Fragment>
      <div></div>
    </React.Fragment>
  );
};
